import { AvailableLanguage } from '@/models/AvailableLanguage';
import Category from '@/models/Category';
import { Family } from '@/models/Family';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
    name: Yup.string()
        .required()
        .min(1),
    path: Yup.string().required(),
});

export const formInitialState = {
    mainImage: undefined,
    name: '',
    description: undefined,
    author: undefined,
    path: '',
    subtitle: '',
    category: { name: '', id: undefined } as Category,
    category2: { name: '', id: undefined } as Category,
    tags: [],
    workload: undefined,
    availableSubtitles: [] as AvailableLanguage[],
    families: [] as Family[],
};

export const formErrors = {
    nameError: false,
    authorError: false,
    categoryError: false,
    category2Error: false,
    tagsError: false,
    pathError: false,
};
